module.exports = __webpack_public_path__ + "static/startup_photo-b48e7ba6de957773291dd36085a4ad61.jpg";